import { useCallback, useState } from 'react';
import { AssetTypesService } from '../../../../services/assetTypesService';
import { useNotifications } from '../../../../hooks/useNotifications';

const useAssetType = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [dataAssetType, setDataAssetType] = useState();
  const { showErrorNotification } = useNotifications();

  const getAssetType = useCallback(
    async (id) => {
      setIsLoading(true);
      try {
        const data = await AssetTypesService.getById(id);
        setDataAssetType(data.assetType);
      } catch (error) {
        showErrorNotification({
          title: 'error',
          description: 'errorRetrievingRecords',
        });
      } finally {
        setIsLoading(false);
      }
    },
    [showErrorNotification],
  );

  return {
    getAssetType,
    isLoading,
    dataAssetType,
  };
};

export default useAssetType;
